var map = {
	"./arrow.svg": "7/y1",
	"./arrows.svg": "hdac",
	"./close.svg": "mq5u",
	"./copy.svg": "rjgy",
	"./facebook.svg": "k7cH",
	"./mail.svg": "+zzn",
	"./nosop3.svg": "CTUF",
	"./popup-1.png": "mnly",
	"./popup-2.png": "v31t",
	"./popup-3.png": "ef6C",
	"./static-bg.jpg": "VFUC",
	"./teheran.jpg": "z8vi",
	"./thumb-1.jpg": "Cu5f",
	"./thumb-1.png": "bGTQ",
	"./thumb-2.jpg": "lMWc",
	"./thumb-2.png": "qDqe",
	"./twitter.svg": "L5PP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "czpq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = czpq
// module chunks = 1